'use client';

import { FunctionComponent, Suspense, type ReactElement } from 'react';

import { type ContentOptions } from '@/services/isomorphic/ContentService';
import PrepareClientContent from '@/react/components/content/core/PrepareClientContent';

export interface IFetchContentWhenActiveProps {
  /**
   * The content options for the fetched content.
   */
  options: ContentOptions;
  /**
   * When this is set to true, the content will be fetched.
   */
  isActive: boolean;

  /** Show this content while the content loads. */
  fallback?: ReactElement;

  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * Renders the content, but only after the isActive flag is set to true.` */
export const FetchContentWhenActive: FunctionComponent<
  IFetchContentWhenActiveProps
> = ({ options, isActive, fallback = null, handleLinkClick }) => {
  return (
    <>
      {isActive ? (
        <Suspense fallback={fallback}>
          <PrepareClientContent
            handleLinkClick={handleLinkClick}
            options={options}
          />
        </Suspense>
      ) : (
        <>{fallback}</>
      )}
    </>
  );
};
